<template>
  <div>
    <spinner-round
      v-if="loading"
      :is-loading="loading" />
    <form
      v-else-if="!loading && u"
      id="form-user"
      @submit.prevent.stop="submit()">
      <div>
        <div class="has-background-dark is-padding-left is-padding-right">
          <div class="has-text-white is-size-6 is-padding-top-xxsmall is-padding-bottom-xxsmall">
            <span class="icon is-small is-size-7 is-margin-right-xxsmall">
              <i class="fas fa-check-circle" /></span>
            <i>Information obligatoire pour la validation du formulaire</i>
          </div>
        </div>
      </div>
      <div class="is-padding">
        <div class="field">
          <r-label
            :is-required="true"
            :label="'Civilité'"
            :value="u.title" />
          <div class="control">
            <div class="columns is-variable is-2 is-multiline is-vcentered">
              <div class="column is-3 is-2-widescreen">
                <input
                  id="M"
                  v-model="u.title"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  type="radio"
                  name="title"
                  value="m">
                <label for="M">M.</label>
              </div>
              <div class="column is-3 is-2-widescreen">
                <input
                  id="Mme"
                  v-model="u.title"
                  class="vadCheckradiocase is-primary is-fullwidth"
                  type="radio"
                  name="title"
                  value="mme">
                <label for="Mme">Mme</label>
              </div>
              <p
                v-if="error.title"
                id="civilityError"
                class="help is-danger column is-paddingless">
                La civilité est obligatoire.
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <v-input
              id="last_name"
              v-validate="'required|min:2'"
              :name="'last_name'"
              :model="u.last_name"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Nom"
              @input="u.last_name = $event.trim()">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Nom'"
                :value="u.last_name" />
            </v-input>
          </div>
          <div class="column">
            <v-input
              id="first_name"
              v-validate="'required|min:2'"
              :name="'first_name'"
              :model="u.first_name"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Prénom"
              @input="u.first_name = $event.trim()">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Prénom'"
                :value="u.first_name" />
            </v-input>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <v-input
              id="email"
              v-validate="'required|min:3|max:255|email'"
              :name="'email'"
              :classes-input="'is-fullwidth'"
              :model="u.email"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Adresse mail"
              :has-addons="true"
              @input="val => u.email = val">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Adresse mail'"
                :value="u.email" />
              <p
                slot="addonLeft"
                class="control">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-paper-plane" /></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column">
            <phone-input
              :key="u.pk"
              :value="u.phone"
              :placeholder="'Numéro de téléphone'"
              :required="false"
              @input="u.phone = $event">
              <r-label
                slot="label"
                :is-required="false"
                :label="'Téléphone (fixe ou mobile)'"
                :value="u.phone"
                :truncate="false">
                <span
                  class="is-padding-left-xsmall"
                  v-helper.top="'6BNfgrh0uP7V5UyMRsZvQp'">
                  <i class="fal fa-info-circle" />
                </span>
              </r-label>
            </phone-input>
          </div>
        </div>
        <div
          v-if="currentUser.account.external_connection && currentUser.account.external_connection.length"
          class="columns">
          <div class="column is-size-6">
            <v-input
              id="id_externe"
              name="id_externe"
              :model="u.external_id"
              :errors-bag="errors"
              :input-type="'id'"
              data-vv-value-path="val"
              data-vv-as="ID Externe"
              :has-addons="true"
              @input="val => u.external_id = val">
              <r-label
                slot="label"
                :is-required="false"
                :label="'ID Externe'"
                :value="u.external_id"
                :truncate="false">
              </r-label>
            </v-input>
          </div>
          <div class="column"></div>
        </div>
        <div class="field">
          <r-label
            :label="'Photo de profil'"
            :for-id="''"
            :is-required="false" />
          <upload-file
            :custom-id="'avatar'"
            :source-documents="pictures"
            :unique="true"
            :is-square-input="false"
            @upload="uploadPictures"
            @deleteDocument="deleteUserPicture" />
        </div>
      </div>
      <div
        v-if="currentUser && currentUser.profil === 'admin' && !isMe"
        class="has-background-light is-padding">
        <div class="title is-5">
          <b class="is-uppercase">Profil de l'utilisateur</b>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field columns is-gapless is-column is-space-between is-height-full">
              <r-label
                :label="'Rôle / Fonction '"
                :value="u.profil"
                :for-id="'profil'" />
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    id="profil"
                    v-model="u.profil"
                    class=""
                    @change="updateHelperText()">
                    <option :value="null">
                      Selectionnez le profil
                    </option>
                    <option value="admin">
                      Admin
                    </option>
                    <option value="manager">
                      Manager
                    </option>
                    <option value="seller">
                      Vendeur
                    </option>
                  </select>
                </div>
                <div
                  v-if="u.profil == 'manager'"
                  class="is-padding-top">
                  <input
                    id="active_all_contact"
                    v-model="u.active_all_contact"
                    name="active_all_contact"
                    class="switch is-success is-rounded"
                    type="checkbox">
                  <label
                    for="active_all_contact"
                    class=""><span>Peut gérer la base contact</span></label>
                </div>
              </div>
              <div
                v-if="error.profil"
                class="help is-danger column is-paddingless is-padding-top-xsmall is-padding-bottom-xsmall">
                Le champ Profil est obligatoire.
              </div>
            </div>
          </div>
          <div class="column">
            <div
              v-if="u.profil && profilHelperText"
              class="notification is-warning is-size-6 is-height-full"
              v-html="profilHelperText" />
          </div>
        </div>
        <div
          v-if="(isAdmin || isManager) && showManagerForm"
          class="columns">
          <div class="column">
            <div class="field">
              <r-label
                :label="'Manager'"
                :is-required="false"
                :value="u.manager" />
              <div class="control">
                <multiselect
                  v-model="u.manager"
                  :placeholder="''"
                  :options="managers"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  class="multiselect--option-ico"
                  :custom-label="sellerName"
                  @search-change="getManagers">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="managers.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun manager trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Sélectionnez ou saisissez un manager</span>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isNew"
        class="columns is-multiline is-padding">
        <p class="column is-12 is-size-5 has-text-grey is-padding-bottom-xsmall">
          Souhaitez-vous inviter ce nouvel utilisateur à finaliser la création de son compte pour lui permettre
          d'effectuer sa première connexion ?
        </p>
        <div class="column">
          <div class="field">
            <input
              id="invit"
              v-model="invitUser"
              class="is-checkradio"
              :value="true"
              type="radio"
              name="invit">
            <label
              for="invit"
              class="">Oui, lui envoyer une invitation</label>
          </div>
          <div class="field">
            <input
              id="notInvit"
              v-model="invitUser"
              class="is-checkradio"
              :value="false"
              type="radio"
              name="notInvit">
            <label
              for="notInvit"
              class="">Non, lui envoyer une invitation plus
              tard</label>
          </div>
        </div>
      </div>
      <submit-sticky-buttons
        button-id="userForm"
        :loading="submitLoading"
        @submit="submit" />
    </form>
  </div>
</template>

<script>
import { User } from '@/mixins'

export default {
  name: 'UserForm',
  components: {
    UploadFile: () => import('@/components/utils/form/UploadFile')
  },
  mixins: [User],
  data () {
    return {
    }
  },
  watch: {
    'u.title' (v) {
      this.error.title = false
    },
    'u.profil' (v) {
      this.error.profil = false
      if (v === 'seller') {
        this.getManagers()
      }
    }
  }
}
</script>
